module.exports = __webpack_public_path__ + "static/media/102-andorra.7d5013ad.svg";